'use strict';

angular.module('licensure.services')
    .factory('ServiceUserCertificationRequirements', ['$http', '$q', function ($http, $q) {

        return {
            getServiceUserCertificationRequirements: function (serviceId) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/Core/ServiceUserCertificationRequirements/Services/' + serviceId)
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        d.reject(response);
                    });

                return d.promise;
            },

            saveServiceUserCertificationRequirements: function (serviceId, saveRequest) {
                var d = $q.defer();

                $http
                    .post(apiLocation + '/api/Core/ServiceUserCertificationRequirements/Services/' + serviceId, saveRequest)
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        d.reject(response);
                    });

                return d.promise;
            },

        }
    }])
;